// export const URL_SERVICIOS_INTERNA = 'https://localhost:44300/';
// export const URL_SERVICIOS = 'http://52.232.183.21:5001/';
export const URL_SERVICIOS_INTERNA = 'https://gestionafiliaciones.nobissalud.com:5003/';
